<template>
<div class="virtualTicket">
   <!-- 电脑端虚拟票券核销页面 -->
  <div class="web-check">
    <div
      class="check-input"
    >
      <Input
        v-model="formItem.checkTicketCode"
        placeholder="请输入核销码或用扫码枪扫码"
        style="width: 400px;"
      />
      <Button
        type="primary"
        @click="checkCode"
      >
        核销
      </Button>
    </div>
    <div class="checked-ticket">已核销票券</div>
    <div class="checked-nums">今日已核销{{ todayCheckTotalNums }}笔</div>
    <!-- 列表 -->
    <Table
      ref="table"
      border
      :columns="columns"
      :data="data"
      :loading="loading"
    />
    <Page
      v-if="total"
      :total="total"
      class-name="pages"
      show-elevator
      show-sizer
      show-total
      @on-change="changepage"
      @on-page-size-change="pageSizeChange"
    />
    <!-- 核销券信息弹窗 -->
    <Modal
      v-model="isShow"
      title="核销信息"
    >
      <template v-if="codeInfo">
        <div class="detail">
          <div class="image">
            <img :src="codeInfo.imgUrl" alt="图片加载失败">
          </div>
          <div class="content">
            <div class="name-and-price">
              <div class="name-nums">
                {{ codeInfo.ticketBasicName || codeInfo.ticketName}}
              </div>
              <div class="price">
                <span class="unit">￥</span>{{ codeInfo.salePrice.toFixed(2) }}
              </div>
            </div>
            <div class="code">
              票券码：{{ codeInfo.checkTicketCode || codeInfo.checkNo }}
            </div>
            <div
              v-if="codeInfo.checkDays"
              class="time"
            >
              票券有效期：购买当日起{{ codeInfo.checkDays }}天可用
            </div>
            <div
              v-if="codeInfo.checkBegDay && codeInfo.checkEndDay"
              class="time"
            >
              票券有效期：{{ `${codeInfo.checkBegDay} - ${codeInfo.checkEndDay}` }}
            </div>
            <div
              v-if="codeInfo.startTime && codeInfo.endTime"
              class="time"
            >
              票券有效期：{{ `${codeInfo.startTime} - ${codeInfo.endTime}` }}
            </div>
          </div>          
        </div>
        <div class="notice">
          使用须知：{{ codeInfo.notice }}
        </div>
      </template>
      <template v-else>
        暂无信息
      </template>
      <template #footer>
        <Button type="ghost" @click="isShow = false">
          取消
        </Button>
        <Button type="primary" @click="confirmCheckCode">
          确认核销
        </Button>
      </template>
    </Modal>
  </div>
</div>
 
</template>
<script>
import { apiGet, apiPost } from '@/fetch/api';
export default {
  components: {},
  provide() {
    return {
      reload: this.reload
    };
  },
  filters: {
    // 日期格式化 年-月-号
    getFormatDate (date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const day = d.getDate();
      return `${year}年${month}月${day}号`;
    },
  },
  data() {
    return {
      formItem: {
        checkTicketCode: '', // 核销码
      },
      todayCheckTotalNums: 0,
      codeInfo: null, // 核销码获取的信息
      searchForm: {
        mainUserId: this.$route.query.mainUserId, // 主账号id
        page: 1,
        limit: 10,
        order: 'DESC', // DESC 倒叙, ASC
        sort: 'checkTime', // checkTime， createTime , modifyTime
      },
      loading: false,
      data: [], // 数据
      total: 0, // 总页数
      columns: [
        {
          title: '票券名称',
          key: 'ticketName',
        },
        {
          title: '核销码',
          key: 'checkNo',
          align: 'center',
        },
        {
          title: '核销时间',
          key: 'checkTime',
          align: 'center',
        },
      ],
      isShow: false, // 核销券信息
    };
  },
  created() {
    if (this.$route.query.mainUserId) {
      this.searchForm.mainUserId = this.$route.query.mainUserId;
    } else {
      this.searchForm.mainUserId = this.getQueryString('mainUserId');
    }
    this.getList();
  },
  methods: {
    // 获取参数
    getQueryString(name) {  
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = null;
      if (window.location.search)  {
        r = window.location.search.substr(1).match(reg);  
      } else if (window.location.hash) {
        r = window.location.hash.substr(1).match(reg); 
      } else if (window.location.href) {
        r = window.location.href.substr(1).match(reg); 
      }
      return r ? unescape(r[2]) : null;  
    },
    // 分页 每页展示条数
    changepage(page) {
      this.searchForm.page = page;
      this.getList();
    },
    // 分页 页数
    pageSizeChange(size) {
      this.searchForm.page = 1;
      this.searchForm.limit = size;
      this.getList();
    },
    // 获取已核销虚拟票券列表
    getList() {
      this.loading = true;
      let operatorId= this.getQueryString('operatorId');
      apiPost('/product/api/virtualTicket/getCheckedTicketList',{...this.searchForm,operatorId}).then(res => {
        if (res.status === 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        } else {
          this.$Message.error(res.message);
        }
        this.loading = false
      });
      this.getTodayCheckTotalNums();
    },
    // 获取当日核销总数
    getTodayCheckTotalNums() {
      let operatorId= this.getQueryString('operatorId');
      apiGet('/product/api/virtualTicket/todayCheckedNum', {
        operatorId,
        mainUserId: this.searchForm.mainUserId,
      }).then(res => {
        if (res.status === 200) {
          this.todayCheckTotalNums = res.data ? res.data : 0;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // 根据核销码进行查询核销码信息
    checkCode() {
      if (!this.formItem.checkTicketCode) {
        this.$Message.error('请输入核销码');
        return;
      }
      let operatorId= this.getQueryString('operatorId');
      apiGet('/product/api/virtualTicket/getCheckTicketDetail', {
        ...this.formItem,
        mainUserId: this.searchForm.mainUserId,
        operatorId,
      }).then(res => {
        if (res.status === 200) {
          if (res.data) {
            this.codeInfo = res.data;
            this.isShow = true;
          } else {
            this.$Message.error('请输入正确的核销码');
            this.isShow = false;
          }
        } else {
          this.$Message.error(res.message);
          this.isShow = false;
        }
      });
    },
    // 确认核销
    confirmCheckCode() {
      if (!this.codeInfo) {
        this.$Message.error('暂无核销信息进行核销，请确认核销码是否正确！');
        return;
      }
      const { amount, orderDetailId, orderDetailModelId, checkNo, virtualTicketStatus } = this.codeInfo;
      // ("0","待消费"),("1", "已退单"), ("2", "已核销"), ("3", "核销中");
      if (virtualTicketStatus === '2') {
        this.$Message.error('此票券已核销');
        return;
      } else if (['1', '3'].includes(virtualTicketStatus)) {
        this.$Message.error('此票券不是待核销状态，不能核销，请确认票券可用');
        return;
      }
      let operatorId= this.getQueryString('operatorId');
      let operatorName= this.getQueryString('operatorName');
      apiPost('/order/webapi/orderInfo/checkOrderByHandle', {
        mainUserId: this.searchForm.mainUserId,
        operatorName,
        operatorId,
        checkNo,
        orderDetailId, // 订单明细ID
        orderDetailModelIds: orderDetailModelId, // 实名制ID，多个逗号拼接
        orderType: 'virtualTicket', // 订单业务类型
        checkAmount: amount, // 核销数量
      }).then(res => {
        if (res.success) {
          this.$Message.success('核销成功');
          this.changepage(1);
          this.isShow = false
        } else {
          this.$Message.error(res.message);
        }
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.virtualTicket {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  overflow-y: auto;
  background: #FFF;
  .web-check {
    width: 80%;
    margin: 0 auto;
    .check-input {
      text-align: center;
      margin-bottom: 100px;
    }
  }
  .checked-ticket {
    padding: 5px 0;
    font-weight: bold;
    border-bottom: 1px solid #e9eaec;
  }
  .checked-nums {
    padding: 5px 0;
    color: #F05B47;
  }
  .pages {
    margin-top: 10px;
    text-align: center;
  } 
}
// .code,
// .time,
.detail,
.notice
 {
  padding: 0 0 5px 0;
}
.detail {
  display: flex;
  font-size: 18px;
  font-weight: bold;
  .image {
    img {
      width: 80px;
      height: 80px;
    }
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: space-around;
    .name-and-price {
      display: flex;
      .name-nums {
        flex: 1;
        padding-left: 10px;
      }
      .price {
        width: 80px;
        padding-left: 10px;
      }
    }
    .code {
      padding-left: 10px;
      font-size: 14px;
    }
    .time {
      padding-left: 10px;
      font-size: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/virtualTicket/index.vue